import { useEffect } from "react";

import { useKitItemsContext } from "@contexts/kit-items";

import { useModal } from "@stadium/hooks/lib/use-modal";
import KitStatusModal from "@components/modals/kit-status";

import { KIT_STATUS_MODAL } from "@constants/modal-types";
import { KIT_STATE_LIVE, KIT_STATE_EXPIRED } from "@stadium/constants/kits";

const IMMUTABLE_KIT_STATE = [KIT_STATE_LIVE, KIT_STATE_EXPIRED];

const KitLayout = ({ children }) => {
  const { kitState } = useKitItemsContext();

  const { openModal, renderModal } = useModal(KIT_STATUS_MODAL, KitStatusModal);

  useEffect(() => {
    if (IMMUTABLE_KIT_STATE.includes(kitState?.toLowerCase())) {
      openModal();
    }
  }, [kitState]);

  return (
    <>
      {children}
      {renderModal(
        {
          closeOnBackdropClick: false,
          kitState,
        },
        false,
      )}
    </>
  );
};

export default KitLayout;
